import {Swiper} from "swiper";
import {Autoplay, Pagination} from "swiper/modules";

import {createSwiper} from "../../utils/swiper";

export const CallToActionsSlider = {
	swiper: null as Swiper | null,

	init(): void {
		this.swiper = createSwiper('[data-swiper="call-to-actions"]', 'call-to-actions__widget', {
			modules: [
				Autoplay,
				Pagination
			],
			autoplay: {
				delay: 6000,
				disableOnInteraction: true,
				pauseOnMouseEnter: true
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true
			},
			slidesPerView: 1,
			spaceBetween: 0,
			centeredSlides: false,
			direction: "horizontal",
			loop: true,
			mousewheel: false
		});
	},

};
